import * as React from "react";

function SvgBBiconsSuccesNotice(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <path
        d="M100 1a99 99 0 1099 99 99 99 0 00-99-99zm57.14 63.42l-56 79.78a7.5 7.5 0 01-12.57-.45L43.7 99a7.5 7.5 0 0110.6-10.65l39.8 39.74 50.76-72.29a7.5 7.5 0 0112.28 8.62z"
        data-name="Obecn\xE9 ikony"
      />
    </svg>
  );
}

export default SvgBBiconsSuccesNotice;
